module.exports = __webpack_public_path__ + "static/media/wounded.d4126360.jpg";